import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import { getLocalities } from '../services/api';

const TrendingLocalities = () => {
  const [localities, setLocalities] = useState({});
  const [activeTab, setActiveTab] = useState('');

  useEffect(() => {
    getLocalities().then(data => {
      setLocalities(data || {});
      const keys = Object.keys(data || {});
      if (keys.length > 0) setActiveTab(keys[0]);
    });
  }, []);

  const tabs = Object.keys(localities);

  return (
    <section id="localities" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="text-red-500 text-sm font-semibold uppercase tracking-wider">LOCALITIES</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-2">
            Top Projects In Trending Localities
          </h2>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-5 py-2.5 rounded-full text-sm font-semibold transition ${
                activeTab === tab
                  ? 'bg-red-500 text-white shadow-md'
                  : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Locality Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {(localities[activeTab] || []).map((loc, idx) => (
            <Link
              to={`/in/${activeTab.toLowerCase()}/${loc.slug}`}
              key={idx}
              className="bg-white rounded-xl p-5 flex items-center justify-between hover:shadow-md transition-shadow cursor-pointer group border border-gray-100"
            >
              <div className="flex items-center space-x-4">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                  idx % 2 === 0 ? 'bg-red-50' : 'bg-blue-50'
                }`}>
                  <span className={`text-lg font-bold ${
                    idx % 2 === 0 ? 'text-red-500' : 'text-blue-500'
                  }`}>
                    {loc.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 group-hover:text-red-500 transition">
                    {loc.name}
                  </h3>
                  <p className="text-sm text-gray-500">{loc.projects} Projects</p>
                </div>
              </div>
              <FaChevronRight className="text-gray-400 group-hover:text-red-500 transition" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrendingLocalities;
